import styled from 'styled-components';

export const LoadingScreen = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.colours.sparklingSnow};
`;

export const ScheduledDeletionDate = styled.div`
  margin-bottom: 1rem;
`;
